import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteParatikaPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParatika/deleteParatikaPosInsatallment',
      requesterInfo,
    })
  }

  public async deleteParatikaPosInsatallment(request: string): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?guid=${request}`
    return await this.postAsync<CommonPostResponse>()
  }
}

